export const getIsPayAndGo = (plan: Plan) => {
  return !!plan?.is_payg;
};
